import { Text } from "@chakra-ui/react"
import { formatCurrency } from "@/utilities/number"
import { useAuth } from "contexts/auth"
import { useStore } from "contexts/store"
import GuestPriceNotice from "./GuestPriceNotice"

const SingleProductPrice = ({ price, originalPrice, unit = "₫" }) => {
    const { user } = useAuth()
    const { store } = useStore()
    const canShowPrice = !!user || !!store?.web?.public_price_display

    if (!canShowPrice) {
        return <GuestPriceNotice />
    }

    const displayPrice = price ?? originalPrice

    return (
        <Text textStyle="md" fontWeight="medium" letterSpacing="tight" mt="2" color={"red.500"}>
            {formatCurrency(displayPrice)} {unit}
        </Text>
    )
}

export default SingleProductPrice